import { Link } from "react-router-dom";
import { Map as MapIcon, Sparkles, Leaf, Landmark, ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import Reveal from "./Reveal";

const PILLARS = [
  { id: "map", to: "/map", Icon: MapIcon, img: "/images/story-alahsa-unesco.webp" },
  { id: "knowledge", to: "/knowledge", Icon: Sparkles, img: "/images/story-darb-zubaidah.webp" },
  { id: "varieties", to: "/varieties", Icon: Leaf, img: "/images/ajwa.webp" },
  { id: "regions", to: "/regions", Icon: Landmark, img: "/images/city-alula.webp" },
];

export default function HomePillars() {
  const { t } = useApp();
  return (
    <section className="home-pillars" data-testid="home-pillars">
      {PILLARS.map((p, k) => (
        <Reveal key={p.id} delay={k * 90}>
          <Link to={p.to} className="pillar-card" data-testid={`pillar-${p.id}`}>
            <img src={p.img} alt="" loading="lazy" className="pillar-img" />
            <div className="pillar-shade" />
            <div className="pillar-body">
              <span className="pillar-ic"><p.Icon size={18} /></span>
              <h3>{t(`home.pillar.${p.id}`)}</h3>
              <p>{t(`home.pillar.${p.id}.d`)}</p>
              <span className="pillar-go">{t("home.pillar.go")} <ArrowRight size={13} className="rtl-flip" /></span>
            </div>
          </Link>
        </Reveal>
      ))}
    </section>
  );
}
